import styled from "styled-components";
import sectionBgSubmitVideo from "images/section-bg-submit-video.jpg";
import sectionBgSubmitVideoMobile from "images/section-bg-submit.video-mobile.jpg";

const VideoSubmissionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 100px;
  align-self: stretch;
  background: ${(props) => props.theme.colors.primary.black};
  .video-submission-text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .video-submission-title {
    color: ${(props) => props.theme.colors.primary.contrast};
    text-align: center;
    font-family: Mulish;
    font-size: 100px;
    font-style: normal;
    font-weight: 600;
    line-height: 130px;
    letter-spacing: 2px;
    padding: 0;
  }
  .video-submission-image {
    position: absolute;
    top: 0;
  }
  .video-submission-row-container {
    display: flex;
    height: 480px;
    padding: 80px 95px;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    background: url(${sectionBgSubmitVideo}), lightgray 50%;
  }
  .why-work-with-jukin-container {
    display: flex;
    width: 545px;
    height: 320.3px;
    padding: 30px 75px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.8);
    margin-right: 20px;
  }
  .why-work-with-jukin-title {
    color: ${(props) => props.theme.colors.primary.darkBlue};
    text-align: center;
    font-family: Mulish;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    margin: 0;
  }
  .why-work-with-jukin-description {
    color: ${(props) => props.theme.colors.primary.darkBlue};
    text-align: center;
    font-family: Mulish;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin: 0;
  }

  @media (max-width: 1023px) {
    .video-submission-row-container {
      background: url(${sectionBgSubmitVideoMobile}), lightgray 50%;
      background-size: cover;
    }
    .video-submission-image {
      display: none;
    }
    .video-submission-title {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 35px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
      letter-spacing: 0.7px;
      width: 251px;
    }

    .video-submission-row-container {
      display: flex;
      width: 100%;
      height: 100%;
      padding: 100px 30px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 30px;
    }
    .why-work-with-jukin-container {
      display: flex;
      width: 330px;
      padding: 30px;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.8);
      height: 266px;
      margin: 0;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    .video-submission-row-container {
      flex-direction: row;
    }
  }

  @media (max-width: 360px) {
    .why-work-with-jukin-container {
      width: 100%;
      margin: 0;
      height: 100%;
    }
  }
  @media (min-width: 1921px) {
    .video-submission-row-container {
      background-repeat: round;
    }
  }
`;

export default VideoSubmissionContainer;
